// import scss
import '../styles/main.scss';

// import js
// import $ from 'jquery'

import app from './components/app';
import homepage from './components/homepage';
import search from './components/search'
import testimonials from './components/testimonials'

// add new components here
var components = {
  app,
  homepage,
  search,
  testimonials
};

// import all components and save in components object
$(function() {
  const app = new components["app"]();
  const testimonials = new components["testimonials"]();
  testimonials.init();
  app.init();
  console.log(app.getSiteName());
  const pageClass = $("body").data("scope");
  // if (pageClass) {
  //   new components[pageClass]().init();
  // }
});